// extracted by css-extract-rspack-plugin
export default {"container":"SectionFilters-module__container__ZzAsRoa"};